import {Form} from 'antd'
import apiBaseline from '@/biz/baseline/apiBaseline.mjs'
import Checkbox from '@/components/Form/Checkbox.jsx'
import TextArea from '@/components/Form/TextArea.jsx'
import {Modal, useOpenModal} from '@/components/Modal/index.mjs'
import {AbortError} from '@/script/Error.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'

export const canPublishProduct = () => () => {
    return function (node) {
        if (! this.permission.has('write')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const {bizNodeType, pkid, stsCode} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能发布', [node])
            return false
        }

        if (! /^(DRAFT|REVISE)$/.test(stsCode)) {
            this.logger.error('只有草稿/修订状态的制品才能发布', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.publish) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持发布`, [node])
            return false
        }

        return (
            ! node.parent ||
            bn.isMounted(this, node)
        )
    }
}

const FormItemUpgrade = ({prjId, sVer, ...props}) => {
    const {data} = useSwrNoCache(
        () => apiBaseline.read({prjId, sVer})
    )

    if ('INCREMENT' === data?.pblType) {
        return null
    }

    return (
        <Form.Item name="upgradeDp" {...props}>
            <Checkbox>制品升版</Checkbox>
        </Form.Item>
    )
}

const ModalPublish = ({prjId, sVer, onOk, ...props}) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.submit()
    }

    const cssForm = {
        '.ant-form-item': {
            marginBottom: 0,
        }
    }

    return (
        <Modal
            title="发布模型制品"
            width={400}
            {...props}
            onOk={handleOk}
            onFinish={onOk}
            css={cssForm}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onOk}
            >
                <Form.Item name="memo">
                    <TextArea
                        autoSize={false}
                        rows={5}
                        placeholder="备注"
                    />
                </Form.Item>

                <FormItemUpgrade
                    prjId={prjId}
                    sVer={sVer}
                />
            </Form>
        </Modal>
    )
}

export const publishProduct = () => {
    const openModal = useOpenModal()

    return () => async function (nodes) {
        const {prjId, sVer} = this.data

        const extra = await openModal(
            <ModalPublish
                prjId={prjId}
                sVer={sVer}
            />
        )

        if (! extra) {
            throw new AbortError()
        }

        const results = await Promise.allSettled(
            [...nodes].map(
                async node => {
                    try {
                        const _n = this.nodeProxy(node)
                        //await _n.lintTree()
                        await _n.publish(extra)
                        this.logger.info('发布模型制品成功', [node])
                    }
                    catch (err) {
                        this.logger.error(
                            `发布模型制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )

        const isOk = results.some(e => 'rejected' !== e.status)

        if (isOk) {
            this.resetChangeHistory()
        }

        return results
    }
}
